import React, { useState, useEffect, useContext } from "react";
import { Modal,Spinner } from "react-bootstrap";
import "../assets/css/Style.css";
import '../../src/styles/billingConfirmation.css';
import paymentConfirmImg from '../assets/images/Payment-Confirm/confirm.svg';
import paymentConfirmImgQ5 from '../assets/images/Payment-Confirm/confirm-Q5.svg';
import { GetPayLoad } from "../services/PayLoadStorage"; /* st48236 - changes for schedule payment */
import { postApiService } from "../services/ApiService"; /* st48236 - changes for schedule payment */
import { toast } from 'react-toastify';/* st48236 - changes for schedule payment */
import { LanguageContext } from "../contexts/LanguageContext";/* st48236 - changes for schedule payment */
import { is } from "date-fns/locale";
import { getApiService } from "../services/ApiService"; // st48236 - to handle loading state for confirmation popup
import Cookies from 'js-cookie';


const Scheduledpayments = ({ columns, rows, nodatatext, confirmationlbl,serviceError }) => {

    /* st48236 - changes for schedule payment */
    const { pageContent } = useContext(LanguageContext);
    const [billingContent, setBillingContent] = useState([]);
    const Payload = GetPayLoad('PayLoad');
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier
    };
    const [cancelConfNum, setCancelConfNum] = useState('');
    const [cancelDataSource, setCancelDataSource] = useState('');
    const [isCancelPayLoading, setCancelPayLoading] = useState(false);
    const [isCancelSubmitting, setIsCancelSubmitting] = useState(false);
    const [isCancelBtnSubmitting, setIsCancelBtnSubmitting] = useState(false);
    const [cancelPayPopupModal, setCancelPymntModelModal] = useState(false);
    const [confirmationPayPopupModal, setConfirmationPymntsPopupModal] = useState(false);
    const [genericContent, setGenericContent] = useState([]);
    const [transactionDetails, setTransactionDetails] = useState([]);
    const [readOnlyMode, setReadOnlyMode] = useState(false);

    useEffect(() => {

        // Check for read-only mode based on owning carrier or any other condition
        setReadOnlyMode(Payload?.readOnlyAccess === true);
        
        if (pageContent?.billing) {
            setBillingContent(pageContent.billing);
        }   
    }, [pageContent]); 
    
    const handleCancelPayment = (e, data_source, data_confnum) => {   
        
        if (Cookies.get('owningCarrier') === 'C4') {
             
            handleFiservLogin();
        }

        if (Cookies.get('owningCarrier') !== 'C4') {
                    
            setCancelConfNum(data_confnum);
            setCancelDataSource(data_source);
            setCancelPymntModelModal(true);
            setIsCancelBtnSubmitting(true);

        }
       
    };

    const handleCloseCancelPymntsPopupClick = () => {
        setIsCancelSubmitting(false);
        setIsCancelBtnSubmitting(false);
        setCancelPymntModelModal(false);
    };

    const handleCancelPaymentClick = (e) => {
        if (e) e.preventDefault();
        setCancelPayLoading(true);
        setIsCancelSubmitting(true);        
        const payload = new FormData();
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const targetCancelPymentUrl = process.env.REACT_APP_API_SCHPYMNT_CALL_ENDPOINT;
        let conf_num = document.getElementById('cancel_conf_num').value;
        let cancel_source = document.getElementById('cancel_data_source').value;
        payload.append("region", Payload?.region);
        payload.append("carrier", Payload?.owning_carrier);
        payload.append("cim", Payload?.cim);
        payload.append("conf_num", conf_num);
        payload.append("case_num", Payload?.case_num);
        payload.append("cancel_source", cancel_source);
        payload.append("action", 'cancel_payment');
        postApiService(baseUrl, targetCancelPymentUrl, payload, headers).then((response) => {
            console.log('response', response?.data?.data[0]['status_message']);
            if (response?.data && response?.data?.status == 'SUCCESS') {
                setCancelPayLoading(false);
                setIsCancelSubmitting(false);
                const result = response.data.data;                
                toast.success('Payment Cancelled Successfully!');
                setCancelPymntModelModal(false);
                document.getElementById(conf_num).remove();
                const closeButton = document.querySelector('.btn-close');
                if (closeButton) {
                    closeButton.click();
                }
            } else {
                setCancelPayLoading(false);
                setIsCancelSubmitting(false);
                toast.error('Error - Cancel Payment API Call - Something went wrong', response?.data?.message);
            }
        })
        .catch(error => {
            setCancelPayLoading(false);
            setIsCancelSubmitting(false);
            toast.error('Error - Cancel Payment API Call - Something went wrong', error);
        });
    };

    const handleCloseConfirmationPymntsPopupClick = () => {
        setConfirmationPymntsPopupModal(false); 
    };

    const formatDate = (date) => {
		if (!date) return "";
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
		const day = String(date.getDate()).padStart(2, "0");
		return month + '/' + day + '/' + year;
	};

    const openConfirmationPage = (e, data_source, conf_num,pymt_type,schedule_date,amt,lastfournum,transid) => {        
        let current_date = formatDate(new Date());
        // st48236 - to handle loading state for confirmation popup - start
        const targetBillingDetailsUrl = process.env.REACT_APP_GET_CONFIRMATION_PAYMENT_DETAILS_ENDPOINT;
        getApiService(baseUrl, targetBillingDetailsUrl, { cim: Payload?.cim, conf_num: transid,'source':data_source,carrier:Payload?.owning_carrier,'last_4':lastfournum?.slice(-4)}, headers)
            .then((response) => {
                if (response?.data?.statusCode !== 200) {
                    toast.error(serviceError);
                }else{
                    const result = response.data.data;  
                    pymt_type = result?.type || pymt_type;
                    schedule_date = result?.entry_date ? formatDate(new Date(result.entry_date)) : formatDate(new Date(result.settlement_date));
                    const transactionDetails = [
                        { label: (confirmationlbl ? confirmationlbl[3] : 'Confirmation Number'), value: (conf_num)?conf_num:'' },
                        { label: (confirmationlbl ? confirmationlbl[4] : 'Date'), value: (current_date)?current_date:'' },
                        { label: (confirmationlbl ? confirmationlbl[5] : 'Type of Transaction'), value: (pymt_type) ? pymt_type !== 'EFT' ? (Cookies.get('owningCarrier') === 'Q5' ? billingContent?.billing_debit_txt : pymt_type) : (Cookies.get('owningCarrier') === 'Q5' ? billingContent?.billing_autopay_eft_txt : pymt_type) : '' },
                        { label: (confirmationlbl ? confirmationlbl[6] : 'Status'), value: (confirmationlbl ? confirmationlbl[9] : 'Success'), isStatus: true },
                        { label: (confirmationlbl ? confirmationlbl[7] : 'Scheduled For'), value: (schedule_date)?schedule_date:'' },
                        { label: (confirmationlbl ? confirmationlbl[8] : 'Payment Amount'), value: (amt)?amt:'' }
                    ];
                    setTransactionDetails(transactionDetails);
                    setConfirmationPymntsPopupModal(true);
                }
            })
            .catch(error => {
                toast.error(serviceError);
            });
        // st48236 - to handle loading state for confirmation popup - end
    };

    const handleFiservLogin = () => {
        
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
            const targetFiservUrl = baseUrl + process.env.REACT_APP_API_FISERV_LOGIN_ENDPOINT;
          
            // Create a form element
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = targetFiservUrl;
            form.target = '_blank'; // Open in a new tab or window
        
            // Add form fields
            const fields = {
              cim: Payload?.cim,
              region: Payload?.region,
              case_num: Payload?.case_num,
              "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
              "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
              "X-Hps-Region": Payload?.region,
              "X-Hps-Carrier": Payload?.owning_carrier
            };
        
            for (const key in fields) {
              if (fields[key] !== undefined) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = fields[key];
                form.appendChild(input);
              }
            }
            // Append the form to the body, submit it, and remove it
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        }

    return (
        <>
            <Modal size="x1" show={cancelPayPopupModal} onHide={handleCloseCancelPymntsPopupClick}>
                <Modal.Header className={`multipleaccounts pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
                    <Modal.Title>
                        {/* <h4 style={{ color: '#110081' }}>Cancel Payment</h4> */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <input type="hidden" id="cancel_conf_num" name="cancel_conf_num" value={cancelConfNum} />
                    <input type="hidden" id="cancel_data_source" name="cancel_data_source" value={cancelDataSource} />
                    <div className="qtip-content" id="qtip-0-content" aria-atomic="true">
                        <p tabIndex={0}>{billingContent?.billing_schedule_payment_base_cancel_payment_info_one ? billingContent?.billing_schedule_payment_base_cancel_payment_info_one : "By cancelling this payment your account will not be drafted."}</p>
                        <p tabIndex={0}>{billingContent?.billing_schedule_payment_base_cancel_payment_info_two ? billingContent?.billing_schedule_payment_base_cancel_payment_info_two : "This operation can not be undone. Do you wish to continue?"}</p>
                        <button className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 cancelrequestbtn" onClick={() => handleCloseCancelPymntsPopupClick()}>Resume Payment</button>
                        <button className="btn btn-secondary btn-lg mt-4 col-5 switchtoebillbtn" onClick={() => handleCancelPaymentClick()} disabled={isCancelSubmitting}>Cancel Payment</button>
                    </div>
                    {isCancelPayLoading && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                            <Spinner animation="border" role="status" ></Spinner>
                            <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            <Modal size="x1" show={confirmationPayPopupModal} onHide={handleCloseConfirmationPymntsPopupClick}>
                <Modal.Header className={`multipleaccounts pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
                    <Modal.Title>
                        {/* <h4 style={{ color: '#110081' }}>Cancel Payment</h4> */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div tabIndex={0} className="col-12 paymemt-confrm">
                        <div className="text-center">
                            <img src={Cookies.get('owningCarrier') === 'Q5' ? paymentConfirmImgQ5 : paymentConfirmImg} alt="Payment confirmed" className="img-fluid" />
                            <h4 className="mb-2 mt-3 fw-semibold payment-success-title">{confirmationlbl ? confirmationlbl[0] : 'Payment Successful!'}</h4>

                            <p className="mt-2 mb-2 text-black payment-process">
                                {confirmationlbl ? confirmationlbl[1] : 'Your payment has been processed successfully'}
                            </p>
                        </div>
                        <div className='mt-4 d-grid justify-content-xl-center justify-md-center'>
                            <div className="confrm-box rounded-4 p-3">
                                <p className="mb-3 fw-semibold text-black">{confirmationlbl ? confirmationlbl[2] : 'Transaction Details'}</p>

                                {transactionDetails.map((detail, index) => (
                                    
                                    <div key={index} className="col-12 d-flex mt-2">
                                        <div className="text-start col-6">
                                            <label className="detail-label">{detail.label}</label>
                                        </div>
                                        <div className="text-end col-6 fw-semibold">
                                            {detail.isStatus ? (
                                                <button tabIndex={-1} className="btn btn-success btn-sm confirmationbtn">
                                                    <i className="fe fe-check fe-11 me-1"></i>
                                                    {detail.value}
                                                </button>
                                            ) : (
                                                <label className="detail-value">{detail.value}</label>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <table className="table table-striped" style={{ marginLeft: '' }} tabIndex={0}>
                <thead className="sticky-top">
                    <tr>
                        {
                            columns && columns?.map((item,index) => <th scope="col" key={index}>{item}</th>)
                        }
                    </tr>
                </thead>
                <tbody>
                    {rows?.length === 0 ? (
                         <td colSpan={7} className="fw-semibold paymenthistorymodal">
                            <div className="d-flex px-2">
                    <div className="col-12 mb-2">
                      <h6 className="paymenthistorymodal">{nodatatext}</h6>
                    </div>
                  </div>
                          </td>
                    ) : (
                    rows && rows?.map((item, index) => <tr key={index} className="border-bottom" id={item?.conf_num} >
                        <td>{item.scheduled_on_date}</td>
                        <td>{item.event_date}</td>
                        <td>{(item.type === 'EFT via Web' && Cookies.get('owningCarrier') === 'Q5') ? billingContent?.billing_payment_type_eft_web_txt : item.type}</td>
                        <td>{item.name}</td>
                        <td 
                            tabIndex={item.conf_num !== 'N/A' ? 0 : -1}
                            className={
                                item.conf_num === 'N/A' 
                                    ? '' 
                                    : Payload?.owning_carrier === 'Q5' 
                                        ? 'anchor-text anchor-text-q5' 
                                        : 'text-decoration-underline'
                            }
                            style={{ cursor: item.conf_num === 'N/A' ? '' : 'pointer' }}
                            onClick={(e) => item.conf_num !== 'N/A' && openConfirmationPage(e, item?.data_source, item?.conf_num, item?.pymt_type,item?.event_date,item?.amount,item.last4,item.trans_id)} // st48236 - to handle loading state for confirmation popup
                            onKeyDown={(e) => {
                                if (item.conf_num !== 'N/A' && (e.key === 'Enter' || e.key === ' ')) {
                                    e.preventDefault();
                                    openConfirmationPage(e, item?.data_source, item?.conf_num, item?.pymt_type,item?.event_date,item?.amount,item.last4,item.trans_id); // st48236 - to handle loading state for confirmation popup
                                }
                            }}
                        >
                            {item.conf_num}
                        </td>
                        <td>{item.amount}</td>
                        <td>
                        {!readOnlyMode ? (
                            <button
                                className={`btn ${Payload?.owning_carrier === 'Q5' ? 'btn-outline-secondary' : 'btn-primary'}`}
                                style={{borderRadius: '14px'}} 
                                data-conf_num={item?.conf_num}
                                data-source={item?.data_source}
                                onClick={(e) => handleCancelPayment(e, item?.data_source, item?.conf_num)}
                                onKeyDown={(e) => handleCancelPayment(e, item?.data_source, item?.conf_num)}
                                disabled={isCancelBtnSubmitting}>
                                    {billingContent?.billing_payment_history_cancel_btntext ? billingContent?.billing_payment_history_cancel_btntext : Payload?.owning_carrier !== 'C4' ? "Cancel":"Manage Payment"}
                                </button>
                            ) : (<span>NA</span>)
                            }
                        </td>
                    </tr>)
                    )}
                </tbody>
            </table>
        </>
    )
}

export default Scheduledpayments;